<template>
  <div>
    <div>
      <FormItem :label="$t('part.title')">
        <Row>
          <Col span="24">
            <Select
              v-model="manufacturerPartSelect"
              filterable
              clearable
              capture
              transfer
              remote
              :remote-method="hanldeSearchManufacterPart"
              :placeholder="$t('part.search_placeholder')"
              placement="bottom-start"
              :loading="loading" @on-change="hanldeManufacterPartSelect">
              <Option v-for="item in manufacturerParts" :value="item.id" :key="'mp_' + item.id"
                :label="_.get(item, 'part_identity.part_number') + ' ' + manufacturerPartLabel(item)" class="mp-select-row">
                {{_.get(item, 'part_identity.part_number')}}
                <div class="mp-specification">
                  {{manufacturerPartLabel(item)}}
                  {{item.specification}}</div>
              </Option>
            </Select>
          </Col>
        </Row>
      </FormItem>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { fnThrottle } from '@/libs/util'
export default {
  name: 'ManufacturerPartSelect',
  props: {
    manufacturerPartId: {
      default: null
    },
    partId: {
      default: null
    },
    allowCreatePart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      preSearchKeyword: '',
      manufacturerPartSelect: null,
      manufacturerParts: []
    }
  },
  computed: {
    partSelectDisabled: function () {
      return this.parts.length === 0 || !this.parts
    }
  },
  watch: {
    manufacturerPartId: function () {
      this.handleLoadManufacturerPart()
    }
  },
  mounted () {
    this.handleLoadManufacturerPart()
  },
  methods: {
    ...mapActions([
      'searchManufacturerPart',
      'getPart'
    ]),
    fnThrottle,
    manufacturerPartLabel(manufacturerPart) {
      if (manufacturerPart) {
        return '[ ' + _.filter(
          _.valuesIn(
            _.pick(manufacturerPart, ['mpn', 'brand', 'chinese_name']
            )
          )).join(' ] [ ') + ' ]'
      } else {
        return null
      }
    },
    handleLoadManufacturerPart () {
      if (this.manufacturerPartId) {
        this.getPart(this.manufacturerPartId).then(res => {
          this.manufacturerParts = [res]
          this.manufacturerPartSelect = res.id
        })
      }
    },
    hanldeSearchManufacterPart (keyword) {
      if (keyword && keyword !== this.preSearchKeyword && keyword.length >= 2) {
        this.loading = true
        this.searchManufacturerPart({ keyword: keyword, terms: { reviewed: 1 } }).then((res) => {
          this.manufacturerParts = res.data
          this.loading = false
          this.preSearchKeyword = keyword
        })
      }
    },
    hanldeManufacterPartSelect (manufacturerPartId) {
      if (manufacturerPartId) {
        let manufacturerPart = _.find(this.manufacturerParts, (item) => {
          return item.id === manufacturerPartId
        })

        this.$nextTick(() => {
          this.$emit('update:manufacturerPartId', manufacturerPartId)
          this.$emit('update:manufacturerPart', manufacturerPart)
          this.$emit('update:partId', _.get(manufacturerPart, 'part_identity.id'))
        })
      } else {
        this.$nextTick(() => {
          this.$emit('update:manufacturerPartId', null)
          this.$emit('update:partId', null)
        })
      }
    },
    clearSelect () {
      this.manufacturerPartSelect = null
    }
  }
}
</script>

<style lang="less">

  .mp-select-row {
    max-width: 720px;
    overflow: hidden;
    font-size: 10px;
    word-wrap: break-word;

    .mp-specification {
      color: gray;
    }
    .mp-attributes {
      padding-right: 5px;
      min-width: 128px;
    }
  }
  .part-form-drawer {
    .ivu-drawer-wrap {
      z-index: 1200;
    }
  }
</style>
